//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import autocomplete from '~/mixins/components/autocomplete';

export default {
  name: 'autocomplete-cargo-type',
  mixins: [autocomplete],
  props: {
    contract: {
      type: [String, Number],
      default: null,
    },
  },
  data () {
    return {
      updateKey: 1,
      searchKeys: [
        {
          name: 'name',
          weight: 1,
        },
        {
          name: 'code',
          weight: 2,
        },
      ],
    };
  },
  computed: {
    params () {
      return { ...(this.contract && { contract: this.contract }) };
    },
  },
  watch: {
    contract: {
      handler () {
        this.updateKey += 1;
      },
    },
  },
};
